import SbuxDialog2 from "../../../../components/SbuxDialog2";
import SbuxTranslate from "../../../../components/SbuxTranslate";
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { useAppDispatch } from "../../../../store/types";
import { deleteClosureMsg } from "../../../../services/closureMsg";

interface Props {
  row: Record<string, unknown>;
  title: string;
  name: string;
  open: boolean;
  isSingleInstance: boolean;
  toggleDialogOpen: () => void;
  toggleCancelDialog: () => void;
}

const ClosureSingleDeleteDialog = ({
  row,
  title,
  name,
  open,
  isSingleInstance,
  toggleDialogOpen,
  toggleCancelDialog,
}: Props) => {
  const dispatch = useAppDispatch();

  const handleOkayClick = async () => {
    toggleCancelDialog();
    toggleDialogOpen();
    if (row.type === "Repeat" && isSingleInstance) {
      let occurrenceId: string | null = null;
      const occurrences = row.occurrences as
        | Record<string, Record<string, unknown>>
        | undefined;
      for (const key in occurrences) {
        const value = occurrences[key];
        if (
          value.startDate === row.startDate &&
          value.endDate === row.endDate
        ) {
          occurrenceId = key;
        }
      }

      const deleteSingleOccurence = {
        id: row.id,
        hoursCode: row.hoursCode,
        occurrenceId: occurrenceId,
        repeatPattern: { ...(row.repeatPattern as Record<string, unknown>) },
      };
      await dispatch(
        deleteClosureMsg(deleteSingleOccurence as Record<string, unknown>),
      );
    } else {
      const deleteObj = {
        id: row.id,
        hoursCode: row.hoursCode,
      };
      await dispatch(deleteClosureMsg(deleteObj as Record<string, unknown>));
    }
  };

  const dialogConfig = {
    title,
    hasBackdrop: false,
    asModal: true,
  };

  return (
    <SbuxDialog2
      open={open}
      config={dialogConfig}
      handleOnClose={toggleDialogOpen}
    >
      <DialogContent dividers>
        <Typography variant="h5">
          <SbuxTranslate>{`Are you sure you want to delete `}</SbuxTranslate>
          <span>{`${name}?`}</span>
        </Typography>
      </DialogContent>

      <DialogActions>
        <Box className="actionContainer">
          <Button variant="contained" size="medium" onClick={handleOkayClick}>
            <SbuxTranslate>{`Okay`}</SbuxTranslate>
          </Button>
          <Button variant="outlined" size="medium" onClick={toggleCancelDialog}>
            <SbuxTranslate>{`Cancel`}</SbuxTranslate>
          </Button>
        </Box>
      </DialogActions>
    </SbuxDialog2>
  );
};

export default ClosureSingleDeleteDialog;
